import { PERMISSION_NAMES } from "./catalogue";
import { PERMISSION_WILDCARD } from "./permission";
/**
 * The platform roles (`D52`) — two, in code, not in a table.
 *
 * Creating a role now requires a deploy. For two roles that change rarely that
 * is the advantage: the bootstrap lockout dissolves because `admin` always
 * exists (`D62` grants the first one by hand), and renaming a permission is a
 * compile error here rather than a seed migration nobody re-runs.
 *
 * These are PLATFORM roles. The four in-group roles — `owner`, `admin`,
 * `trainer`, `student` (`D50`) — are a different vocabulary living on the
 * membership row, and `admin` appearing in both is a coincidence of English,
 * not a shared value.
 */
export const ROLE_NAMES = ["admin", "member"];
/**
 * What each role holds.
 *
 * `member` holds NOTHING platform-level, and that is the point: the ability to
 * act inside a group comes from membership (`D50`), never from a platform
 * role. A `member` entry that grew permissions would be a second place where
 * group authority is decided.
 */
export const ROLE_PERMISSIONS = Object.freeze({
    admin: Object.freeze([PERMISSION_WILDCARD]),
    member: Object.freeze([]),
});
export function isRoleName(value) {
    return ROLE_NAMES.includes(value);
}
/**
 * Roles expanded and de-duplicated into one flat list (`D52`), for the
 * `permissions` claim.
 *
 * Both roles and permissions travel in the token: the app may gate a screen on
 * either, because a screen is not a security boundary. The SERVER accepts only
 * a permission — a gate naming a role means the day someone needs that single
 * ability you either grant the whole role or hunt every gate.
 *
 * Unknown role names are ignored rather than throwing. This runs while minting
 * a token, and a role removed from the code above while a row still names it
 * must degrade to fewer permissions, not to a login that fails.
 */
export function permissionsForRoles(roles, direct = []) {
    const expanded = new Set(direct);
    for (const role of roles) {
        if (!isRoleName(role)) {
            continue;
        }
        for (const permission of ROLE_PERMISSIONS[role]) {
            expanded.add(permission);
        }
    }
    return [...expanded];
}
/** Every name a role or a grant may legally carry — the catalogue plus `*`. */
export const GRANTABLE_NAMES = Object.freeze([
    PERMISSION_WILDCARD,
    ...PERMISSION_NAMES,
]);
//# sourceMappingURL=roles.js.map